<template>
<div class="chapter">
<div class="inner_page">
<div class="_idGenObjectStyleOverride-1">
<img src="image/Hambly_IP-MireMap-print.png"/>
</div>
<div class="_idGenObjectStyleOverride-1">
<img src="image/Hambly_IP-MorneMap-print.jpg"/>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// IronPrincess-3.vue?0d274c4a